<template>
<div>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="step==='paid'?$t('pay.payResult'):$t('pay.payWay')" center width="700px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <!-- 2023-12-5 17:54:22 支付成功弹框改为绿色消息 -->
      <template v-if="isShowNewWindow&&step==='paid'">
        <div class="dialog-ctr w100p">
          <div class="mydialog df-l-c-fs">
            <img src="@/assets/icons/payok.png" class="pay-result-icon">
            <div class="f-m f-dark">{{$t('pay.paySuccess')}}</div>
            <div class="f-m mt40 pay-result-text">{{selectedPayText}}</div>
          </div>
        </div>
        <div class="dialog-btm w100p df-c-sa">
          <div class="themebtn" @click="close">{{$t('common.comfirm')}}</div>
        </div>
      </template>
      <template v-else>
        <div class="dialog-ctr w100p">
          <div class="df-c-sb" v-if="showBindCustomerBtn">
            <div class="pt20 plr40" v-if="isShowMember">
              <div class="themebtn-s" @click="bindOrderCustomer">{{$t('member.bindMemberAndCalc')}}</div>
            </div>
            <div class="df-c-fs pt20 plr40" @click="bindOrderDiscount">
              <img style="width:24px;height:24px;margin-right:12px;" src="@/assets/icons/discount.png" />
              <div class="f-m">{{$t('coupon.discountCode')}}</div>
            </div>
          </div>
          <div class="mydialog df-w-c-fs">
            <div v-for="(x,i) in paytypes_x" :key="i" class="item df-l-c-ct" @click="submitDialogPay(x)">
              <div class="imgbox df-c-ct">
                <img :src="x.icon|toimg" style="max-width:60px;max-height:60px;">
              </div>
              <div class="name" :class="sysEnv_x==='us'?'f-m':'f-xs'">{{x['name'+_lang]}}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>

  <el-dialog
    :visible.sync="isShowDialogCard" class="dialog-square"
    :title="$t('pay.payCardComfirm')" center width="700px"
    :close-on-click-modal="false" @close="closeDialogCard">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct h100p" style="height: 240px;">
          <div class="f-m f-dark text">{{$t('pay.payCardComfirmTip')}}</div>
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="closeDialogCard">{{$t('pay.payNot')}}</div>
        <div class="themebtn" @click="submitDialogCard">{{$t('pay.payComfirm')}}</div>
      </div>
    </div>
  </el-dialog>

  <DialogCash ref="DialogCash" @submitDialog="submitDialogCash" />

  <DialogScan ref="DialogScan" @submitDialog="submitDialogScan" />

  <el-dialog
    :visible.sync="isShowDialogPos" class="dialog-square"
    :title="$t('pay.payCardComfirm')" center width="700px"
    :close-on-click-modal="false" @close="closeDialogPos">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct h100p" style="height: 240px;">
          <div class="f-m f-dark text">{{$t('reader.readerWaiting')}}</div>
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="closeDialogPos">{{$t('pay.payNot')}}</div>
        <!-- <div class="themebtn" @click="submitDialogCard">{{$t('pay.payComfirm')}}</div> -->
      </div>
    </div>
  </el-dialog>

</div>
</template>

<script>
import DialogCash from '@/components/DialogCash'
import DialogScan from '@/components/DialogScan'
import {loadStripeTerminal} from '@stripe/terminal-js'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'DialogPay',
  components: { DialogCash, DialogScan },
  props: ['showBindCustomerBtn'],
  data() {
    return {
      isShowDialog: false,
      step: '', // start/paid/scanning
      isCan: true,

      payPrice: 0,
      parentOrderId: '',
      customerId: '',
      selectedPayWay: '',

      isShowDialogCard: false,
      isShowDialogPos: false,

      cashResult: {
        received: 0,
        refund: 0,
      },

      // #region stripe
      terminal: null,
      discoveredReaders: [],
      discoveredReader: {},
      paymentIntentId: '',
      // #endregion
    }
  },
  computed: {
    ...mapState(['paytypes_x']),
    selectedPayText() {
      if (this.selectedPayWay === 5) {
        return `${this.$t('calc.received')}：${this.toprice(this.cashResult.received, 2)} / ${this.$t('calc.change')}：${this.toprice(this.cashResult.refund, 2)}`
      } else if (this.selectedPayWay !== '') {
        const ITEM = this.paytypes_x.find(x => x.value === this.selectedPayWay)
        return `${ITEM['name' + this._lang]}：${this.toprice(this.payPrice, 2)}`
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapMutations(['paytypes_x_save']),
    async open(obj) {
      // console.log(`%corderData:`, 'color: #00f;', obj)
      this.payPrice = obj.cash
      this.parentOrderId = obj.poid
      this.customerId = obj.uid
      // 如果当前支付方式列表为空，可能是请求失败，这里重新请求一次
      if (this.paytypes_x.length === 0) {
        await this.initPayType()
      }
      // 如果再次请求依然是空列表，需要提示用户
      if (this.paytypes_x.length === 0) {
        this.$message.error(this.$t('pay.payTypeIsEmpty'))
        return
      }
      this.resetPayType()
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      // 如果已经支付完成了
      if (this.step === 'paid') {
        this.$emit('close')
        let timer = setTimeout(() => {
          this.step = 'start'
          clearTimeout(timer)
        }, 300)
      }
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.isCan = true
      this.payPrice = 0
      this.parentOrderId = ''
      this.customerId = ''
    },
    // 银行卡支付对话框 关闭支付结果
    closeDialogCard() {
      this.isCan = true
      this.isShowDialogCard = false
    },
    closeDialogPos() {
      this.isShowDialogPos = false
      // this.terminal = null
      if (this.terminal && this.step !== 'paid') {
        console.log(`%c调用cancelCollectPaymentMethod函数`, 'color: #00f;', )
        this.terminal.cancelCollectPaymentMethod().then(res => {
          console.log(`%c调用cancelCollectPaymentMethod函数结果`, 'color: #00f;', res)
          if (JSON.stringify(res) === '{}') {
            this.el_loading_long_x_save(false)
          }
        })
      }
    },
    closeAllDialog() {
      this.close()
      // this.isShowDialogCard = false
      this.closeDialogCard()
      // this.isShowDialogPos = false
      this.closeDialogPos()
      this.$refs.DialogCash.close()
      this.$refs.DialogScan.close()
    },

    // #region 跳转到结算页
    bindOrderCustomer() {
      this.$emit('navToClac', 'member')
      this.close()
    },
    bindOrderDiscount() {
      this.$emit('navToClac', 'discount')
      this.close()
    },
    // #endregion



    // 支付对话框 提交支付方式
    async submitDialogPay(item) {
      const { value, qfEnable, eftEnable } = item
      console.log(`%cvalue, qfEnable, eftEnable:`, 'color: #f0f;', value, qfEnable, eftEnable)
      console.log(`%cthis.readerId_x:`, 'color: #f0f;', this.readerId_x)
      this.selectedPayWay = value
      if (this.isCan) {
        this.isCan = false
        switch (value) {
          case 28:
            // 余额
            this.isShowDialogCard = true
            break;
          case 5:
            // 现金
            this.$refs.DialogCash.open(this.payPrice)
            break;
          case 1: case 2:
            // 微信 支付宝
            // console.log(`%c店铺QF配置完成:`, 'color: #00f;', this.shop_x.qfComplete)
            // if (!!this.shop_x.qfEnable && !!this.shop_x.qfComplete) {
            //   this.$refs.DialogScan.open()
            //   this.$refs.DialogScan.title = item['name' + this._lang]
            //   this.$nextTick(() => {
            //     this.$refs.DialogScan.$refs.elInput.focus()
            //   })
            // } else {
            //   this.isShowDialogCard = true
            // }
            if (qfEnable) {
              this.$refs.DialogScan.open()
              this.$refs.DialogScan.title = item['name' + this._lang]
              this.$nextTick(() => {
                this.$refs.DialogScan.$refs.elInput.focus()
              })
            } else if (eftEnable && this.readerId_x) {
              this.eftPay('EWALLET')
            } else {
              this.isShowDialogCard = true
            }
            break
          case 11:
            // stripe刷卡机
            this.el_loading_long_x_save(true)
            const StripeTerminal = await loadStripeTerminal()
            console.log(`%cstripe加载完成:`, 'color: #00f;', StripeTerminal)
            // if (!this.terminal) {
              this.terminal = StripeTerminal.create({
                onFetchConnectionToken: this.fetchConnectionToken,
                onUnexpectedReaderDisconnect: this.unexpectedDisconnect,
              })
            // }
            console.log(1111, this.terminal)
            this.terminal && this.discoverReaderHandler()
            break
          case 3: case 4: case 9: case 10: 
            // Mastercard Visa 银联 Amex
            if (eftEnable && this.readerId_x) {
              this.eftPay('EDC')
            } else {
              this.isShowDialogCard = true
            }
            break
          case 8:
            // 八達通
            if (eftEnable && this.readerId_x) {
              this.eftPay('OCTOPUS')
            } else {
              this.isShowDialogCard = true
            }
            break
          case 12: case 13:
            // 信用卡 支票
          default:
            this.isShowDialogCard = true
            break
        }
        let timer = setTimeout(() => {
          this.isCan = true
          clearTimeout(timer)
        }, 1000)
      }
    },

    // #region EFT
    // EFT支付
    async eftPay(TYPE) {
      this.el_loading_x_save(true)
      console.log('EFT', TYPE, this.readerId_x)

      const LAST_PAYMENT_PARAMS = JSON.parse(localStorage.getItem('dola_b_eft_last_payment_is_waiting'))
      if (LAST_PAYMENT_PARAMS) {
        // EFT检查上次支付

        let rD = {
          orderId: LAST_PAYMENT_PARAMS.orderId,
          payType: LAST_PAYMENT_PARAMS.payType,
          ip: LAST_PAYMENT_PARAMS.ip
        }
        console.log(`%cEFT 上一次请求参数:`, 'color: #00f;', rD)

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftQuery, rD)
        console.log(`%cEFT result:`, 'color: #00f;', RESULT)
        if (RESULT) {
          if (RESULT === 'error') {
            // 失败 清除设置的标记
            // this.$message.error(this.$t('pay.eftPayLastFailed'))
            await this.$confirm(this.$t('pay.eftPayLastFailed'), this.$t('common.warning2'), {
              confirmButtonText: this.$t('common.yes'),
              // cancelButtonText: this.$t('common.no'),
              showCancelButton: false,
              type: 'warning'
            // }).then(() => {
            // }).catch(() => {
            })
            localStorage.setItem('dola_b_eft_last_payment_is_waiting', null)
          } else if (RESULT === 'pending') {
            // 超时
            // this.$message.error(this.$t('pay.eftPayLastPending'))
            await this.$confirm(this.$t('pay.eftPayLastPending'), this.$t('common.warning2'), {
              confirmButtonText: this.$t('common.yes'),
              cancelButtonText: this.$t('common.no'),
              // showCancelButton: false,
              type: 'warning'
            }).then(() => {
              localStorage.setItem('dola_b_eft_last_payment_is_waiting', null)
            }).catch(() => {
              return
            })
          } else {
            // 成功 清除设置的标记
            localStorage.setItem('dola_b_eft_last_payment_is_waiting', null)

            // #region 将上一次的订单改为成功
            let rD = {
              shopId: LAST_PAYMENT_PARAMS.shopId,
              id: LAST_PAYMENT_PARAMS.orderId,
              payType: LAST_PAYMENT_PARAMS.payType_,
              printerId: LAST_PAYMENT_PARAMS.printerId,
            }
            this.$api.payment_pay(rD).then(res => {
              if (res.status == 0) {
                // console.log(`%cres.data:`, 'color: #f00;', res.data)
              } else { this._status(res) }
            })
            // #endregion
            
            await this.$confirm(this.$t('pay.eftPayLastSuccessed'), this.$t('common.warning2'), {
              confirmButtonText: this.$t('common.yes'),
              // cancelButtonText: this.$t('common.no'),
              showCancelButton: false,
              type: 'success'
            // }).then(() => {
            // }).catch(() => {     
            })

            if (this.parentOrderId === LAST_PAYMENT_PARAMS.poid) {
              // this.$message.success(this.$t('pay.eftPayLastSuccessed'))
              this.step = 'paid' // 显示支付成功
              this.close()
              return
            }

          }
        }

        // this.$message.error(this.$t('pay.eftPayLastPending'))
        // this.el_loading_x_save(false)
      
      }

      const id = await this.$parent.createChildOrder(true)
      console.log(`%cEFT 支付订单ID:`, 'color: #00f;', id)
      if (id) {
        let rD = {
          shopId: this.currentShopId,
          orderId: id,
          payType: TYPE,
          userCost: this.payPrice,
          ip: this.readerId_x,
        }
        console.log(`%cEFT 请求参数:`, 'color: #00f;', rD)
        localStorage.setItem('dola_b_eft_last_payment_is_waiting', JSON.stringify({
          ...rD,
          shopId: this.currentShopId,
          printerId: this.printerId_x,
          payType_: this.selectedPayWay,
          poid: this.parentOrderId
        }))

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftPay, rD)
        console.log(`%cEFT eftPayResult:`, 'color: #00f;', RESULT)
        if (RESULT) {
          if (RESULT === 'error') {
            // 失败
            this.$message.error(this.$t('pay.eftPayFailed'))
            // 清除设置的标记
            localStorage.setItem('dola_b_eft_last_payment_is_waiting', null)
          } else if (RESULT === 'timeout') {
            // 超时
            this.$message.error(this.$t('pay.eftPayTimeOut'))
          } else {
            // 成功
            // 清除设置的标记
            localStorage.setItem('dola_b_eft_last_payment_is_waiting', null)
            await this.sendPay(id)
          }
        }

      }

      this.el_loading_x_save(false)
      
    },
    // #endregion

    // #region 银行卡支付
    // 银行卡支付对话框 提交支付方式
    async submitDialogCard() {
      this.el_loading_x_save(true)
      const _D = await this.$parent.createChildOrder()
      if (_D) {
        const _R = await this.sendPay(_D)
        if (_R === 'ok') {
          this.isShowDialogCard = false
        }
      }
      this.el_loading_x_save(false)
    },
    // #endregion

    // #region stripe
    fetchConnectionToken() {
      return this.$api.stripe_token({ shopId: this.currentShopId }).then(res => {
        if (res.status === 0) {
          let _R = res.data
          console.log(`%cTOKEN:`, 'color: #f00;', _R)
          return _R
        } else { this._status(res) }
      })
    },
    unexpectedDisconnect() {
      // In this function, your app should notify the user that the reader disconnected.
      // You can also include a way to attempt to reconnect to a reader.
      console.log(`%c与POS机断开连接`, 'color: #00f;', )
      // this.$alert(this.$t('reader.readerError1'), this.$t('common.tips'), {
      //   confirmButtonText: this.$t('common.comfirm'),
      //   callback: action => {}
      // })
    },
    discoverReaderHandler() {
      // this.el_loading_x_save(true)
      var config = {}
      // console.log(process.env.NODE_ENV)
      if (this.isDev) {
        config.simulated = true
      }
      this.terminal.discoverReaders(config).then(res => {
        if (res.error) {
          console.log(`%c发现失败:`, 'color: #00f;', res.error)
          // this.el_loading_x_save(false)
          this.el_loading_long_x_save(false)
          this.$alert(this.$t('reader.readerError2'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.comfirm'),
            callback: action => {}
          })
        } else if (res.discoveredReaders.length === 0) {
          console.log(`%c没有发现:`, 'color: #00f;', res)
          // this.el_loading_x_save(false)
          this.el_loading_long_x_save(false)
          this.$alert(this.$t('reader.readerError3'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.comfirm'),
            callback: action => {}
          })
        } else {
          console.log(`%c发现成功:`, 'color: #00f;', res, this.readerId_x)
          this.discoveredReaders = res.discoveredReaders
          // // this.el_loading_x_save(false)
          // this.el_loading_x_save(true)

          if (this.isDev) {
            this.connectReaderHandler()
          } else {

            const ITEM = res.discoveredReaders.find(x => x.id === this.readerId_x)
            if (ITEM) {
              this.connectReaderHandler()
            } else {
              this.el_loading_long_x_save(false)
              this.$alert(this.$t('reader.readerError4'), this.$t('common.tips'), {
                confirmButtonText: this.$t('common.comfirm'),
                callback: action => {}
              })
            }

          }
        }
      })
    },
    connectReaderHandler() {
      // this.el_loading_x_save(true)
      var selectedReader = this.discoveredReaders[0]
      this.terminal.connectReader(selectedReader).then(res => {
        if (res.error) {
          console.log(`%c连接失败:`, 'color: #00f;', res.error)
          // this.el_loading_x_save(false)
          this.el_loading_long_x_save(false)
          this.$alert(this.$t('reader.readerError5'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.comfirm'),
            callback: action => {}
          })
        } else {
          console.log(`%c连接成功:`, 'color: #00f;', res)
          // // this.el_loading_x_save(false)
          this.collectPayment()
        }
      })
    },
    async fetchPaymentIntentClientSecret() {
      this.oid = ''
      const _D = await this.$parent.createChildOrder()
      if (_D) {
        console.log(`%c订单id:`, 'color: #f00;', _D)
        this.oid = _D

        return this.$api.stripe_secret({
          shopId: this.currentShopId,
          id: this.oid,
          printerId: this.printerId_x,
        }).then(res => {
          if (res.status === 0) {
            let _R = res.data
            console.log(`%csecret:`, 'color: #f00;', _R)
            return _R
          } else { this._status(res) }
        })

      }
    },
    collectPayment() {
      this.fetchPaymentIntentClientSecret().then(client_secret => {
        // this.el_loading_x_save(true)
        console.log(`%cclient_secret:`, 'color: #f00;', client_secret)
        this.el_loading_long_x_save(false)
        if (client_secret) {

          this.isShowDialogPos = true
  
          // if (this.isDev) {
          //   this.terminal.setSimulatorConfiguration({testCardNumber: '4242424242424242'})
          // }
          this.terminal.collectPaymentMethod(client_secret).then(res1 => {
            this.el_loading_long_x_save(true)
            if (res1.error) {
              console.log(`%c采集失败:`, 'color: #00f;', res1, res1.error)
              // this.el_loading_x_save(false)
              this.el_loading_long_x_save(false)
              this.isShowDialogPos = false
              if (res1.error.code !== 'canceled') {
                console.log(`%c非手动取消采集`, 'color: #00f;', )
                this.$alert(this.$t('reader.readerError6'), this.$t('common.tips'), {
                  confirmButtonText: this.$t('common.comfirm'),
                  callback: action => {}
                })
              } else {
                console.log(`%c手动取消采集`, 'color: #00f;', )
              }
            } else {
              console.log(`%c采集信息成功:`, 'color: #00f;', res1)
              this.terminal.processPayment(res1.paymentIntent).then(res2 => {
                if (res2.error) {
                  console.log(`%c处理付款失败:`, 'color: #00f;', res2.error)
                  // this.el_loading_x_save(false)
                  this.el_loading_long_x_save(false)
                  this.isShowDialogPos = false
                  this.$alert(this.$t('reader.readerError7'), this.$t('common.tips'), {
                    confirmButtonText: this.$t('common.comfirm'),
                    callback: action => {}
                  })
                } else if (res2.paymentIntent) {
                  this.paymentIntentId = res2.paymentIntent.id
                  console.log(`%c处理付款成功:`, 'color: #00f;', res2)
                  // this.el_loading_x_save(false)
                  this.el_loading_long_x_save(false)
                  // this.isShowDialogPos = false
                  this.capture()
                }
              })
            }
          })

        }
      })
    },
    capture() {
      return this.$api.stripe_intent({
        shopId: this.currentShopId,
        id: this.paymentIntentId
      }).then(res => {
        if (res.status === 0) {
          let _R = res.data
          console.log(`%c支付成功`, 'color: #f00;', _R)
          this.$parent.judgeCart() // 刷新订单
          this.step = 'paid' // 显示支付成功
          this.isShowDialogPos = false
          this.$parent.sendPayCallback && this.$parent.sendPayCallback(this.oid) // 分菜页面用
          // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
          if (!this.isShowNewWindow) {
            this.close()
          }
        } else { this._status(res) }
      })
    },
    // #endregion
    
    // 修改订单状态為已支付
    async sendPay(id) {
      let rD = {
        shopId: this.currentShopId,
        id,
        payType: this.selectedPayWay,
        printerId: this.printerId_x,
      }
      this.selectedPayWay === 5 && (rD.cashPayCallBack = {
        orderId: id,
        payCash: this.cashResult.received,
        returnCash: this.cashResult.refund,
      })
      if (this.selectedPayWay === 28) {
        rD.customerId = this.customerId
        return this.$api.payment_pay_balance(rD).then(res => {
          if (res.status == 0) {
            // console.log(`%cres.data:`, 'color: #f00;', res.data)
            this.$parent.judgeCart() // 刷新订单
            this.step = 'paid' // 显示支付成功
            this.$parent.sendPayCallback && this.$parent.sendPayCallback(id) // 分菜页面用
            // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
            if (!this.isShowNewWindow) {
              this.close()
            }
            return 'ok'
          } else { this._status(res) }
          this.isCan = true
        })
      }
      return this.$api.payment_pay(rD).then(res => {
        if (res.status == 0) {
          // console.log(`%cres.data:`, 'color: #f00;', res.data)
          this.$parent.judgeCart() // 刷新订单
          this.step = 'paid' // 显示支付成功
          this.$parent.sendPayCallback && this.$parent.sendPayCallback(id) // 分菜页面用
          // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
          if (!this.isShowNewWindow) {
            this.close()
          }
          return 'ok'
        } else { this._status(res) }
        this.isCan = true
      })
    },
    // 現金支付
    async submitDialogCash(result) {
      this.el_loading_x_save(true)
      this.cashResult = result
      console.log(`%c点击了现金支付:`, 'color: #00f;', true)
      const _D = await this.$parent.createChildOrder()
      console.log(`%c点击了现金支付后得到的orderID:`, 'color: #f00;', _D)
      if (_D) {
        const _R = await this.sendPay(_D)
        if (_R === 'ok') {
          this.$refs.DialogCash.close()
        }
      }
      this.el_loading_x_save(false)
    },
    // 扫码支付
    async submitDialogScan(payCode) {
      this.el_loading_x_save(true)
      const _D = await this.$parent.createChildOrder()
      if (_D) {
        let rD = {
          shopId: this.currentShopId,
          orderId: _D,
          payCode,
          payType: this.selectedPayWay,
          printerId: this.printerId_x,
        }
        await this.$api.scan_pay(rD).then(res => {
          if (res.status == 0) {
            this.$parent.judgeCart() // 刷新订单
            this.step = 'paid' // 显示支付成功
            this.$parent.sendPayCallback && this.$parent.sendPayCallback(_D) // 分菜页面用
            this.$refs.DialogScan.close() // 关闭扫码对话框
            // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
            if (!this.isShowNewWindow) {
              this.close()
            }
          } else {
            this._status(res)
            this.$refs.DialogScan.clear()
          }
          this.isCan = true
        })
      }
      this.el_loading_x_save(false)
    },

    async initPayType() {
      const _R = await this.getData('paytype', {
        shopId: this.currentShopId,
        enable: true
      })
      console.log(`%c支付方式:`, 'color: #f00;', _R)
      const RESULT = _R.map(x1 => ({
        name_zh: x1.name_zh,
        name_en: x1.name_en,
        value: x1.type,
        icon: x1.imgId,
        qfEnable: x1.qfEnable,
        eftEnable: x1.eftEnable,
      }))
      this.paytypes_x_save(RESULT)

      if (this.sysEnv_x === 'us') {
        // console.log(this.readerId_x)
        if (!this.readerId_x) {
          const INDEX = this.paytypes_x.findIndex(x => x.value === 11)
          this.paytypes_x.splice(INDEX, 1)
        }
      }
    },
    // 如果打开弹框时绑定了顾客，那么加上一个余额支付
    resetPayType() {
      if (this.isShowMember && this.isShowMemberWallet && this.customerId) {
        // console.log('有顾客id')
        const INDEX = this.paytypes_x.findIndex(x => x.value === 28)
        if (INDEX === -1) {
          this.paytypes_x.push({
            name_zh: '會員錢包',
            name_en: 'Membership',
            value: 28,
            icon: 'dola-cash-wallet.svg',
            qfEnable: false,
            eftEnable: false,
          })
        }
      } else {
        const INDEX = this.paytypes_x.findIndex(x => x.value === 28)
        // console.log(INDEX)
        INDEX > -1 && this.paytypes_x.splice(INDEX, 1)
      }
    },
  },
  created() {
    if (this.paytypes_x.length === 0) {
      this.initPayType()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 40px;
  .item{width: 155px;height: 140px;}
  .imgbox{height: 80px;width: 80px;}
  .name{height: 40px;line-height: 40px;}

  .pay-result-icon{width:60px;height:60px;border-radius: 50%;padding: 60px;}
  .pay-result-text{color: #374978;}
  .text{text-align: center;line-height: 32px;word-break: normal;}
}
</style>